import { ItemType } from '../constants'
import { BaseGraphNode } from '../Nodes/BaseGraphNode'

export const isUserNode = (node: BaseGraphNode) => {
  return node.data!.type === ItemType.User
}
